var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "173.032866px",
    height: "177.007025px",
    viewBox: "0 0 173.032866 177.007025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 180,
    height: 180
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-\\u4E3B\\u754C\\u9762-1",
    transform: "translate(-900, -744.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE5\\u4F5C\\u53F0",
    transform: "translate(120, 598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pic",
    transform: "translate(777, 144)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }), /*#__PURE__*/React.createElement("g", {
    id: 53,
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.775043,62.0800371 C156.896057,62.0800371 159.424773,59.5485152 159.424773,56.4258765 C159.424773,53.3030901 156.896057,50.7717159 153.775043,50.7717159 C150.655507,50.7717159 148.126791,53.3030901 148.126791,56.4258765 C148.126791,59.5485152 150.655507,62.0800371 153.775043,62.0800371 Z M3.71653087,92.6566683 C5.76910343,92.6566683 7.43304845,90.9912905 7.43304845,88.9368569 C7.43304845,86.8824233 5.76910343,85.2170455 3.71653087,85.2170455 C1.66394355,85.2170455 0,86.8824233 0,88.9368569 C0,90.9912905 1.66394355,92.6566683 3.71653087,92.6566683 Z M20.800648,159.532331 C22.8531615,159.532331 24.5172099,157.867692 24.5172099,155.813111 C24.5172099,153.758529 22.8531615,152.092413 20.800648,152.092413 C18.7479869,152.092413 17.0840861,153.758529 17.0840861,155.813111 C17.0840861,157.867692 18.7479869,159.532331 20.800648,159.532331 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "none",
    fill: "#F1F6FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "40.6668692 159.532331 92.8201495 143.190212 92.8201495 76.1891471 40.6668692 92.4052738"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "144.97343 159.532331 92.8201495 143.190212 92.8201495 76.1891471 144.97343 92.4052738"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "92.8201495 176 40.6668692 159.657881 40.6668692 92.6566683 92.8201495 108.99864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "92.8201495 176 144.97343 159.657881 144.97343 92.6566683 92.8201495 108.99864"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "92.8201495 76.1891471 68.2994374 57.8360195 15.2748434 75.6863581 40.6668692 92.4052738"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "92.8201495 76.1891471 117.340861 57.8360195 170.365308 75.6863581 144.97343 92.4052738"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "40.6668692 92.6566683 92.8201495 108.99864 66.8056933 125.591858 15.2748434 108.495703"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "144.97343 92.6566683 92.8201495 108.99864 118.834606 125.591858 170.365308 108.495703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.371342,11.8652419 C114.677734,31.6939459 116.855502,36.0997009 117.570248,55.6380162 C117.295368,60.0979791 117.124916,64.9477364 115.022183,68.852918 C112.214157,74.826713 105.345858,78.9639397 98.8567192,79.0309979 C92.1715753,79.1503439 85.6177414,75.057281 82.667918,68.745684 C80.5925102,64.9152412 80.6585345,59.6756895 83.5054073,56.1979672 C86.6002774,52.8624851 92.0449918,52.030904 95.9616944,54.1148787 C100.270112,56.0941303 102.841662,60.2094967 103.794213,64.5495228 C104.746618,68.889549 104.328168,73.5969183 103.16558,77.8768284 C100.733906,88.2863626 98.719944,88.7898901 92.7566362,106.413796",
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.263499,5.37000903 C116.246513,8.285683 113.533165,10.0709827 110.092369,9.14001072 C106.469453,8.5224399 103.905436,7.88593326 103.740301,5.28367526 C103.823459,2.61493509 106.735175,1.57043674 110.14318,0.393003584 C114.229596,-1.23074638 116.03234,2.52080247 116.263499,5.37000903 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8535309,14.2859763 C94.689656,16.1761616 98.56057,16.7272503 100.446915,13.8402016 C102.515233,10.6397665 104.285777,8.31303803 102.383627,6.17602233 C100.547502,4.28594043 98.7607107,5.55845151 94.6742947,7.18220591 C91.3986332,8.85349189 90.7032365,12.2154871 92.8535309,14.2859763 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.325466,2.22542132 C102.996457,1.51324523 104.998012,2.03572335 105.891186,3.38440608 C106.271675,3.81180627 106.718188,4.48615502 106.850532,4.98002261 C108.27264,8.30416094 107.825535,11.5997035 105.9064,12.378347 C103.805291,13.4703474 100.910562,11.5992161 99.8026242,8.45552938 C99.538084,7.4677942 99.40574,6.9739266 99.2073717,6.23312522 C98.9926081,4.43812124 99.6544758,2.93759741 101.325466,2.22542132 C101.573611,2.15895392 101.325466,2.22542132 101.325466,2.22542132 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "none",
    fill: "#F1F3F9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.325466,2.22542132 C102.996457,1.51324523 104.998012,2.03572335 105.891186,3.38440608 C106.271675,3.81180627 106.718188,4.48615502 106.850532,4.98002261 C108.27264,8.30416094 107.825535,11.5997035 105.9064,12.378347 C103.805291,13.4703474 100.910562,11.5992161 99.8026242,8.45552938 C99.538084,7.4677942 99.40574,6.9739266 99.2073717,6.23312522 C98.9926081,4.43812124 99.6544758,2.93759741 101.325466,2.22542132 Z",
    id: "\\u5F62\\u72B6",
    stroke: "#C2D4FC",
    strokeWidth: 2,
    fill: "#F1F6FF",
    fillRule: "nonzero",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5172099,51.7360841 L21.2823152,51.7360841 L21.2823152,48.5011894 L18.5095904,48.5011894 L18.5095904,51.7360841 L15.2748434,51.7360841 L15.2748434,54.6011247 L18.5095904,54.6011247 L18.5095904,57.8360195 L21.2823152,57.8360195 L21.2823152,54.6011247 L24.5172099,54.6011247 L24.5172099,51.7360841 Z M31.6227232,132.895888 L28.3879762,132.895888 L28.3879762,129.661141 L25.6152515,129.661141 L25.6152515,132.895888 L22.3805044,132.895888 L22.3805044,135.761076 L25.6152515,135.761076 L25.6152515,138.995823 L28.3879762,138.995823 L28.3879762,135.761076 L31.6227232,135.761076 L31.6227232,132.895888 Z M173.032866,133.079042 L169.074363,131.080884 L171.072816,127.122972 L167.680025,125.410181 L165.681571,129.368093 L161.724545,127.369788 L159.955035,130.875279 L163.912061,132.873584 L161.913608,136.831349 L165.3064,138.54414 L167.304853,134.586375 L171.263356,136.584681 L173.032866,133.079042 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "none",
    fill: "#C2D4FC",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.7e172f856b20737abb8cc975e6a6a52f.svg";
export { ForwardRef as ReactComponent };